import React, { Component } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import { CssBaseline, CircularProgress, Container, Grid, Button, Chip, Tabs, Tab } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import MyMaterialTable from '../../components/table';
import Footer from '../../components/footer';
import { FormattedMessage, injectIntl } from 'react-intl';
import SectionCard from '../../components/section-card';
import Typography from '@material-ui/core/Typography';
import Pagination from '@material-ui/lab/Pagination';
import Search from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';
import ClearIcon from '@material-ui/icons/Clear';
import AddIcon from '@material-ui/icons/Add';
import { Link } from 'react-router-dom';
import { ContractStatusBadge, SubscriptionStatusBadge, ProvisioningStatusBadge } from '../../components/status-badge';
import DeprovisionedTrialDetailDialog from '../../components/deprovisioned-trial-detail-dialog';
import DeprovisioningStatsBanner from '../../components/deprovisioning-stats-banner';
import RefreshIcon from '@material-ui/icons/Refresh';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EmptyStateCard from '../../components/empty-state-card';
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import * as componentActions from '../../redux/actions/admin-billing';
import * as adminBillingService from '../../services/admin-billing.service';
import Api from "../../services/api";

const PAGE_SIZE = 10;

class AdminSubscriptionList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            resultList: [],
            totalPages: 0,
            page: 1,
            pageStart: 0,
            pageEnd: 0,
            count: 0,
            searchValue: '',
            statusFilter: '',
            tabValue: 0,
            deprovisionedDialog: { open: false, desprovisioningQueueId: null },
            reloadTick: 0,
        };

        this.callSearch = this.callSearch.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
        this.clearFields = this.clearFields.bind(this);
    }

    componentDidMount() {
        this.getItens(1);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.state === "reload") {
            this.componentDidMount();
        }
    }

    onChangePaginate = (e, page) => {
        this.setState({ page: page });
        this.getItens(page);
    }

    setPagination(count, page) {
        let totalPage = Math.ceil(count / PAGE_SIZE);
        this.setState({ totalPages: totalPage });
        if (count > 0) {
            if (page == 1) {
                this.setState({ pageStart: 1, pageEnd: Math.min(count, PAGE_SIZE) });
            } else {
                let pageStart = ((page - 1) * PAGE_SIZE) + 1;
                this.setState({ pageStart: pageStart, pageEnd: Math.min(page * PAGE_SIZE, count) });
            }
        } else {
            this.setState({ totalPages: 0, page: 1, count: 0 });
        }
    }

    onFieldChange(event) {
        this.setState({ [event.target.name]: event.target.value, page: 1 });
    }

    callSearch() {
        this.getItens(1);
    }

    handleTabChange = (e, newValue) => {
        const filters = ['', 'deprovisioned'];
        this.setState({ tabValue: newValue, statusFilter: filters[newValue], page: 1 }, () => {
            this.getItens(1);
        });
    }

    async clearFields() {
        await this.setState({ searchValue: '', page: 1 });
        this.getItens(1);
    }

    getItens(page = 1) {
        this.setState(s => ({ loading: true, reloadTick: (s.reloadTick || 0) + 1 }));
        const offset = (page - 1) * PAGE_SIZE;

        adminBillingService.getHirers(PAGE_SIZE, offset, this.state.searchValue, this.state.statusFilter)
            .then(result => {
                if (result.data.success) {
                    const data = result.data.data;
                    const count = data.totalcount || 0;
                    const hirers = data.hirers || [];
                    this.setState({ count: count });
                    this.setPagination(count, page);

                    const formattedList = hirers.map(item => ({
                        ...item,
                        lastPaymentDateText: item.lastpaymentdate ? new Date(item.lastpaymentdate).toLocaleDateString('pt-BR') : '-',
                        lastPaymentValueText: item.lastpaymentvalue != null ? `R$ ${item.lastpaymentvalue.toFixed(2)}` : '-',
                    }));

                    this.setState({ loading: false, resultList: formattedList });
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch(err => {
                const intl = this.props.intl;
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    render() {
        const { classes, headerMenu } = this.props;
        const intl = this.props.intl;

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open })}>
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth='xl' style={{ paddingLeft: 0, marginLeft: 0 }}>
                        <CssBaseline />

                        <Grid container className={classes.mb20} spacing={0}>
                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="large"
                                    className={classes.button}
                                    startIcon={<AddIcon />}
                                    style={{ marginRight: 5, marginBottom: 5 }}
                                    component={Link} {...{ to: `/${this.props.match.params.lang}/admin-subscription-create` }}
                                >
                                    {intl.formatMessage({ id: "admin.subscription.create" })}
                                </Button>
                            </Grid>
                        </Grid>

                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <SectionCard
                                    context="list"
                                    title={intl.formatMessage({ id: "admin.subscriptions.title" })}
                                    actions={
                                        <Tooltip title="Atualizar">
                                            <IconButton size="small" onClick={() => this.getItens(this.state.page)}><RefreshIcon /></IconButton>
                                        </Tooltip>
                                    }
                                >
                                    <Grid container spacing={1} alignItems="center">
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                type="text"
                                                name="searchValue"
                                                value={this.state.searchValue}
                                                placeholder={intl.formatMessage({ id: "search" })}
                                                onChange={this.onFieldChange}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                InputProps={{ startAdornment: <Search style={{ color: '#757575', marginRight: 8 }} /> }}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <Button variant='contained' color='secondary' size='medium' onClick={this.callSearch} startIcon={<Search />} style={{ textTransform: 'none' }}>
                                                Buscar
                                            </Button>
                                        </Grid>
                                        <Grid item>
                                            <Button variant='outlined' color='primary' size='medium' onClick={this.clearFields} startIcon={<ClearIcon />} style={{ textTransform: 'none' }}>
                                                Limpar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </SectionCard>
                            </Grid>
                        </Grid>

                        <Tabs value={this.state.tabValue} onChange={this.handleTabChange} indicatorColor="primary" textColor="primary" style={{ marginBottom: 8 }}>
                            <Tab label={intl.formatMessage({ id: "admin.trials.filter.all" })} />
                            <Tab label={intl.formatMessage({ id: "admin.trials.filter.deprovisioned" })} />
                        </Tabs>

                        {this.state.tabValue === 0 && (
                            <div style={{ marginBottom: 12, padding: '8px 12px', backgroundColor: '#fff8e1', borderLeft: '3px solid #ffb300', borderRadius: 4, fontSize: 12, color: '#6d4c00' }}>
                                Assinaturas <strong>desprovisionadas</strong> não aparecem nesta aba. Veja-as na aba <strong>"Desprovisionados"</strong>.
                            </div>
                        )}

                        {this.state.statusFilter === 'deprovisioned' && (
                            <DeprovisioningStatsBanner contractType="non_trial" refreshKey={this.state.reloadTick} />
                        )}

                        {this.state.resultList.length === 0 && !this.state.loading ? (
                            <EmptyStateCard
                                context={this.state.statusFilter === 'deprovisioned' ? 'success' : 'info'}
                                icon={<CardMembershipIcon style={{ fontSize: 56, color: '#bdbdbd' }} />}
                                title={this.state.statusFilter === 'deprovisioned' ? 'Nenhuma assinatura desprovisionada' : 'Nenhuma assinatura encontrada'}
                                description={this.state.statusFilter === 'deprovisioned' ? 'Ainda não há assinaturas neste estado.' : 'Ajuste os filtros ou crie uma nova assinatura.'}
                            />
                        ) : (
                            <MyMaterialTable
                                title=""
                                columns={[
                                    { title: 'Contrato', field: 'contractid' },
                                    { title: intl.formatMessage({ id: "name" }), field: 'name' },
                                    { title: 'Workspace', field: 'workspace' },
                                    {
                                        title: 'Status Contrato',
                                        field: 'contractstatusid',
                                        render: rowData => <ContractStatusBadge statusId={rowData.contractstatusid} />
                                    },
                                    {
                                        title: 'Status Assinatura',
                                        field: 'subscriptionstatus',
                                        render: rowData => rowData.paymentgatewaytype === 'manual'
                                            ? <Chip label="Manual" size="small" style={{ backgroundColor: '#fff3e0', fontWeight: 500, fontSize: 11 }} />
                                            : <SubscriptionStatusBadge status={rowData.subscriptionstatus} />
                                    },
                                    { title: intl.formatMessage({ id: "admin.subscription.last.payment" }), field: 'lastPaymentDateText' },
                                    { title: intl.formatMessage({ id: "admin.subscription.last.value" }), field: 'lastPaymentValueText' },
                                    {
                                        title: 'Status Provisionamento',
                                        field: 'provisioningstatus',
                                        render: rowData => rowData.provisioningstatus ? <ProvisioningStatusBadge status={rowData.provisioningstatus} /> : '-'
                                    },
                                ]}
                                data={this.state.resultList}
                                rowClick={
                                    this.state.statusFilter === 'deprovisioned'
                                        ? (event, rowData) => {
                                            if (rowData?.desprovisioningqueueid) {
                                                this.setState({ deprovisionedDialog: { open: true, desprovisioningQueueId: rowData.desprovisioningqueueid } });
                                            }
                                          }
                                        : (event, rowData) => {
                                            this.props.addCurrentHirer(rowData);
                                            this.props.history.push(`/${this.props.match.params.lang}/admin-subscription-detail`);
                                          }
                                }
                            />
                        )}

                        <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                            <Grid item xs={12} md={3}>
                                <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                            </Grid>
                            <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                                {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                            </Grid>
                        </Grid>

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}
                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />

                        <DeprovisionedTrialDetailDialog
                            open={this.state.deprovisionedDialog.open}
                            desprovisioningQueueId={this.state.deprovisionedDialog.desprovisioningQueueId}
                            onClose={() => this.setState({ deprovisionedDialog: { open: false, desprovisioningQueueId: null } })}
                            onForceDropSuccess={() => this.getItens(this.state.page)}
                            onDataRefreshed={() => this.getItens(this.state.page)}
                            defaultEmail={this.props.userSession?.user?.email || ''}
                        />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

AdminSubscriptionList.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AdminSubscriptionList)));
